import { useCallback, useState } from "react";
import { useSelector } from "react-redux";
import "./App.css";
import { useParams } from "react-router";

import AuthenticatedPage from "./Containers/Pages/Authenticated";
import UnauthedPage from "./Containers/Pages/Unauthed";
import { getSubdomain } from "Util/url";

function App(props) {
  const { page } = props;
  const authToken = useSelector((state) => state.authSlice.authToken);
  const { unauthedPage, emailVerificationToken, email } = useParams();
  const decodedEmail = decodeURIComponent(email);
  const subdomain = getSubdomain();
  // if (!subdomain) {
  //   return <div>Invalid subdomain</div>;
  // }

  console.log("subdomain", subdomain);
  if (emailVerificationToken) {
    return (
      <UnauthedPage
        page={unauthedPage}
        emailVerificationToken={emailVerificationToken}
        email={decodedEmail}
      />
    );
  }

  return (
    <div className="App">
      {authToken ? (
        <AuthenticatedPage authToken={authToken} />
      ) : (
        <UnauthedPage
          page={unauthedPage}
          emailVerificationToken={emailVerificationToken}
          email={decodedEmail}
        />
      )}
    </div>
  );
}

export default App;
